import type { Theme, ThemePreference, ThemeSource } from '../hooks/useTheme'

export const Themes: Record<string, Theme> = {
  LIGHT: 'light',
  DARK: 'dark',
}

// `as const` rather than a `Record<string, ThemePreference>` annotation: the members keep
// their literal types, so comparing against ThemePreferences.SYSTEM narrows a preference to
// a Theme the way a bare 'system' comparison would.
export const ThemePreferences = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const satisfies Record<string, ThemePreference>

export const THEME_STORAGE_KEY = 'theme'

export const ThemeSources: Record<string, ThemeSource> = {
  USER: 'user',
  SYSTEM: 'system',
}
